import { v4 as uuidv4 } from 'uuid';

export default class Image {
  constructor({
    uuid = uuidv4(),
    noteUuid = null,
    data = null,
  } = {}) {
    this.uuid = uuid;
    this.noteUuid = noteUuid;
    this.data = data;
  }
}
